export enum TAB_INDEX {
    ESTABLISHMENT_DATA = 0,
    SUBSTANCES = 1,
    PROVIDERS_AND_BUYERS = 2,
    RADIOLOGICAL_EQUIPMENT = 3,
    WORKERS_AND_MEDICAL_EXAMS = 4,
    RESPONSIBLES_AND_CONTRACTORS = 5
}

/**
 * Clave de traducción (`carcinogenicReport.tabNames.*`) del nombre de cada
 * paso del informe, en el orden de `TAB_INDEX`.
 */
export const CLAVES_NOMBRE_PASO = [
    'tabNames.establishmentData',
    'tabNames.substancesAndPreventiveMeasures',
    'tabNames.providersAndBuyers',
    'tabNames.radiologicalEquipment',
    'tabNames.workersAndMedicalExams',
    'tabNames.responsiblesAndContractors'
] as const;
